wbApp.factory('consentDefinitionSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {

        var ConsentDefinition = $resource('/Api/ConsentsDefinitions/:id', {}, {
            'getAll': { method: 'GET', isArray: true, url: '/Api/ConsentsDefinitions/GetAll' },
            'update': { method: 'POST', url: '/Api/ConsentsDefinitions/Update' },
            'insert': { method: 'POST', url: '/Api/ConsentsDefinitions/Insert' },
            'delete': { method: 'POST', url: '/Api/ConsentsDefinitions/Delete' }
        });

        var consentDefinitions;

        function getAllAsync(refresh) {

            if (!consentDefinitions || refresh) {
                consentDefinitions = repositorySvc.customGet('getAll', ConsentDefinition);
            }

            return consentDefinitions;
        }

        function getAllActiveAsync(refresh, consentDefinitionIDToInclude) {

            var sIDs = consentDefinitionIDToInclude || 0;

            var deffered = $q.defer();
            var filteredConsentDefinitions = [];
            filteredConsentDefinitions.$promise = deffered.promise;

            var all = getAllAsync(refresh);
            all.$promise.then(function (data) {

                var filtered = _.filter(data, function (item) {
                    return item.active || item.consentDefinitionID == sIDs;
                });

                filteredConsentDefinitions.push.apply(filteredConsentDefinitions, filtered);
                deffered.resolve(filteredConsentDefinitions);

            }, function (error) {
                deffered.reject(error);
            });

            return filteredConsentDefinitions;
        }

        function insert(data, successCallback, errorCallback) {
            repositorySvc.insert(
                ConsentDefinition,                  // $resource
                consentDefinitions,                 // collection
                data,                         // entity
                successCallback,
                errorCallback,
                'consentDefinitionID');
        }


        function update(data, successCallback, errorCallback) {
            repositorySvc.update(
                ConsentDefinition,                         // $resource
                consentDefinitions,                         // collection
                data,                                // entity
                successCallback,
                errorCallback,
                'consentDefinitionID');
        }

        function remove(data, successCallback, errorCallback) {
            repositorySvc.remove(
                ConsentDefinition,                            // $resource
                consentDefinitions,                            // collection
                { consentDefinitionID: data.consentDefinitionID },           // entity
                successCallback,
                errorCallback,
                {
                    consentDefinitionID: data.consentDefinitionID
                },
                'consentDefinitionID');
        }

        function createNew() {
            return {
                consentDefinitionID: 0,
                consentTypeID: 1,
                active: true,
                validFrom: null,
                validTo: null,
                validToDays: 365
            };
        }

        function getConsentNameByIDAsync(consentDefinitionID) {
            return $q(function (resolve, reject) {
                getAllAsync().$promise.then(function (data) {
                    resolve(_.find(data, { consentDefinitionID: consentDefinitionID }));
                }, function (error) {
                    reject(error);
                });
            });
        }

        return {
            getAllAsync: getAllAsync,
            insert: insert,
            update: update,
            remove: remove,
            createNew: createNew,
            getAllActiveAsync: getAllActiveAsync,
            getConsentNameByIDAsync: getConsentNameByIDAsync
        }

    }]);